/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M5.738 1.113a.386.386 0 01.547 0l1.738 1.74a.386.386 0 01-.544.546L6.397 2.317v6.45a.386.386 0 01-.772 0v-6.45L4.544 3.4a.385.385 0 01-.545 0 .387.387 0 01-.001-.546l1.74-1.74zm4.876 6.32a.386.386 0 00-.386.387v2.181a.23.23 0 01-.23.23H2a.23.23 0 01-.23-.23V7.819a.386.386 0 00-.771 0v2.488c0 .383.311.693.693.693h8.614a.694.694 0 00.693-.693V7.819a.386.386 0 00-.386-.385z" _fill="#EC8023" fill-rule="nonzero" _stroke="#EC8023" stroke-width=".3"/>'
  }
})
